import React from 'react'
import PropTypes from 'prop-types'
import { PreviewStoreProvider } from 'gatsby-source-prismic'
import { getSlug } from '@/utils/getSlug'
import Layout from '../../layout'
import { useSiteConfig } from '../hooks/useSiteConfig'

/**
 * Prismic Layout is a pre-wrap which pulls in any
 * prismic content to pass to the main Layout component
 */

const LayoutPrismic = ({ path, pageContext, children }) => {
  const site = useSiteConfig()

  const page = {
    title: pageContext.title || '',
    path,
    image: pageContext.image,
    theme: getSlug(pageContext.theme) || 'yellow',
    isHeaderInverse: pageContext.isHeaderInverse,
  }

  return (
    <PreviewStoreProvider>
      <Layout site={site} page={page}>
        {children}
      </Layout>
    </PreviewStoreProvider>
  )
}

LayoutPrismic.defaultProps = {
  children: undefined,
  path: '',
  pageContext: {},
}

LayoutPrismic.propTypes = {
  children: PropTypes.node,
  path: PropTypes.string,
  pageContext: PropTypes.object,
}

export default LayoutPrismic
